import { useContext } from "react";
import { ControlLayoutContext } from "@plansoft-configuration-renderer/layout";
import { defaultAttributeDisplayOptions } from "../../Attributes/AttributeDisplayOptions";
import { useGridLayoutPropsFallback } from "../Common/ValuesGrid/useGridLayoutProps";
/**
 * Provides fallback values for the layout props for the Thumbnail control
 * @returns
 */
export function useThumbnailControlLayoutProps() {
    const contextProps = useContext(ControlLayoutContext);
    const { showDisallowedValues = false, valueSorting = defaultAttributeDisplayOptions.valueSorting, } = contextProps;
    const gridProps = useGridLayoutPropsFallback(contextProps, {
        defaultEnabled: true,
    });
    return Object.assign({ showDisallowedValues,
        valueSorting }, gridProps);
}
//# sourceMappingURL=useThumbnailControlLayoutProps.js.map